/**
 * Canvas Target Detection Utilities
 * 
 * Helper functions to determine if a click/event target is on
 * empty canvas space vs interactive elements.
 */

/**
 * Check if the target element is a pannable canvas element
 * @param {HTMLElement} target - The event target
 * @param {HTMLElement} containerElement - The flowchart container element
 * @returns {boolean}
 */
export function isPannableTarget(target, containerElement) {
  const isContainer = target === containerElement;
  const isCanvas = target.classList?.contains('flowchart__canvas');
  const isGrid = target.classList?.contains('flowchart__canvas-grid');
  const insideCard = target.closest?.('button, .task-node, .decision-node, .kanban-card, .mission-card__wait');
  const isSvg = (target.tagName === 'svg' || target.tagName === 'SVG') && !insideCard;
  const isEdgesContainer = target.classList?.contains('flowchart__edges');
  
  // Only treat paths as pan-able if they're NOT edge hitboxes (which need click events)
  const isPath = (target.tagName === 'path' || target.tagName === 'PATH') && 
                 !target.classList?.contains('flowchart__edge-hitbox') &&
                 !insideCard;
  
  const isFlowchartElement = target.closest?.('.flowchart') === containerElement && 
                             !target.closest?.('.task-node') && 
                             !target.closest?.('.decision-node') &&
                             !target.closest?.('.flowchart-hud__missions') &&
                             !target.closest?.('.minimap') &&
                             !target.closest?.('.flowchart__edge') &&
                             !target.closest?.('.campaign-zone');
  
  return isContainer || isCanvas || isGrid || isSvg || isEdgesContainer || isPath || isFlowchartElement;
}

/**
 * Check if the target element is valid for showing context menu
 * (same as pannable but also excludes handles layer)
 * @param {HTMLElement} target - The event target
 * @param {HTMLElement} containerElement - The flowchart container element
 * @returns {boolean}
 */
export function isContextMenuTarget(target, containerElement) {
  const isContainer = target === containerElement;
  const isCanvas = target.classList?.contains('flowchart__canvas');
  const isGrid = target.classList?.contains('flowchart__canvas-grid');
  const insideCard = target.closest?.('button, .task-node, .decision-node, .kanban-card, .mission-card__wait');
  const isSvg = (target.tagName === 'svg' || target.tagName === 'SVG') && !insideCard;
  const isEdgesContainer = target.classList?.contains('flowchart__edges');
  
  const isPath = (target.tagName === 'path' || target.tagName === 'PATH') && 
                 !target.classList?.contains('flowchart__edge-hitbox') &&
                 !insideCard;
  
  const isFlowchartElement = target.closest?.('.flowchart') === containerElement && 
                             !target.closest?.('.task-node') && 
                             !target.closest?.('.decision-node') &&
                             !target.closest?.('.flowchart-hud__missions') &&
                             !target.closest?.('.minimap') &&
                             !target.closest?.('.flowchart__edge') &&
                             !target.closest?.('.campaign-zone') &&
                             !target.closest?.('.handles-layer__handle');
  
  return isContainer || isCanvas || isGrid || isSvg || isEdgesContainer || isPath || isFlowchartElement;
}
